import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Mousewheel } from 'swiper/modules';
import { Link, useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { CORE_PROJECTS } from '../../constants';
import content from '../../i18n/content';
import 'swiper/css';
import 'swiper/css/pagination';
import './ProjectsCarousel.css';

export default function ProjectsCarousel() {
  const { lang, isRTL } = useLanguage();
  const t = content[lang].projects;
  const projectIds = Object.keys(CORE_PROJECTS);

  const swiperRef = useRef(null);
  const navigate = useNavigate();

  return (
    <section id="projects" className="projects-section">
      <h2>{t.sectionTitle}</h2>

      <div className="carousel-outer">
        <button
          type="button"
          className="carousel-nav carousel-nav--prev"
          onClick={() => swiperRef.current?.slidePrev()}
          aria-label="Previous project"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>

        <div className="carousel-clip">
          <Swiper
            key={lang}
            modules={[Pagination, Mousewheel]}
            dir={isRTL ? 'rtl' : 'ltr'}
            loop
            grabCursor
            pagination={{ el: '.projects-pagination', clickable: true }}
            mousewheel={{ forceToAxis: true }}
            slidesPerView={1.2}
            spaceBetween={16}
            breakpoints={{
              640:  { slidesPerView: 2.0, spaceBetween: 20 },
              1024: { slidesPerView: 2.5, spaceBetween: 24 },
              1280: { slidesPerView: 2.8, spaceBetween: 28 },
            }}
            onSwiper={(swiper) => { swiperRef.current = swiper; }}
            touchStartPreventDefault={false}
          >
            {projectIds.map((id) => {
              const copy = t.items[id];
              const data = CORE_PROJECTS[id];
              return (
                <SwiperSlide key={id}>
                  <Link
                    to={`/projects/${id}`}
                    className="project-card"
                    aria-labelledby={`project-title-${id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(`/projects/${id}`, { state: { scrollY: window.scrollY } });
                    }}
                  >
                    <h3 id={`project-title-${id}`}>{copy.title}</h3>
                    <p className="project-card-description">{copy.description}</p>
                    <div className="project-card-stack">
                      {data.stack.map((tech) => (
                        <span key={tech} className="project-card-chip">{tech}</span>
                      ))}
                    </div>
                    <span className="project-card-cta" aria-hidden="true">
                      {lang === 'he' ? '←' : '→'}
                    </span>
                  </Link>
                </SwiperSlide>
              );
            })}
          </Swiper>
          <div className="projects-pagination" />
        </div>

        <button
          type="button"
          className="carousel-nav carousel-nav--next"
          onClick={() => swiperRef.current?.slideNext()}
          aria-label="Next project"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>
    </section>
  );
}
